const env = process.env;

export const BASE_URL = env.REACT_APP_API_URL;
export const BASE_URL_PARTNER = env.REACT_APP_API_URL_PARTNER;
